export const convertToNepali = (inputText: string) => {
  let outputText: string;
  //Map each input text character
  outputText = inputText
    .toString()
    .split('')
    .map((key) => {
      return unicodeMapping[key] || key;
    })
    .join('');
  //Replace converted values
  replacementRules.forEach((rule) => {
    outputText = outputText.replace(new RegExp(rule[0], 'g'), rule[1]);
  });
  return outputText;
};
/**
 * Following Mapping rules are taken from
 * https://raw.githubusercontent.com/Shuvayatra/preeti/master/preeti.js
 */
/**
 * Unicode Key Mapping
 */
export const unicodeMapping: Record<string, string> = {
  '÷': '/',
  v: 'ख',
  r: 'च',
  '"': 'ू',
  '~': 'ञ्',
  z: 'श',
  ç: 'ॐ',
  f: 'ा',
  b: 'द',
  n: 'ल',
  j: 'व',
  '×': '×',
  V: 'ख्',
  R: 'च्',
  ß: 'द्म',
  '^': '६',
  Û: '!',
  Z: 'श्',
  F: 'ँ',
  B: 'द्य',
  N: 'ल्',
  Ë: 'ङ्ग',
  J: 'व्',
  '6': 'ट',
  '2': 'द्द',
  '¿': 'रू',
  '>': 'श्र',
  ':': 'स्',
  '§': 'ट्ट',
  '&': '७',
  '£': 'घ्',
  '•': 'ड्ड',
  '.': '।',
  '«': '्र',
  '*': '८',
  '„': 'ध्र',
  w: 'ध',
  s: 'क',
  g: 'न',
  æ: '“',
  c: 'अ',
  o: 'य',
  k: 'प',
  W: 'ध्',
  Ö: '=',
  S: 'क्',
  Ò: '¨',
  _: ')',
  '[': 'ृ',
  Ú: '’',
  G: 'न्',
  ˆ: 'फ्',
  C: 'ऋ',
  O: 'इ',
  Î: 'ङ्ख',
  K: 'प्',
  '7': 'ठ',
  '¶': 'ठ्ठ',
  '3': 'घ',
  '9': 'ढ',
  '?': 'रु',
  ';': 'स',
  "'": 'ु',
  '#': '३',
  '¢': 'द्घ',
  '/': 'र',
  '+': 'ं',
  ª: 'ङ',
  t: 'त',
  p: 'उ',
  '|': '्र',
  x: 'ह',
  å: 'द्व',
  d: 'म',
  '`': 'ञ',
  l: 'ि',
  h: 'ज',
  T: 'त्',
  P: 'ए',
  m: 'फ',
  Ý: 'ट्ठ',
  '\\': '्',
  Ù: ';',
  X: 'ह्',
  Å: 'हृ',
  D: 'म्',
  '@': '२',
  Í: 'ङ्क',
  L: 'ी',
  H: 'ज्',
  '4': 'द्ध',
  '±': '+',
  '0': 'ण्',
  '<': '?',
  '8': 'ड',
  '¥': 'र्‍',
  $: '४',
  '¡': 'ज्ञ्',
  ',': ',',
  '©': 'र',
  '(': '९',
  '‘': 'ॅ',
  u: 'ग',
  q: 'त्र',
  '}': 'ै',
  y: 'थ',
  e: 'भ',
  a: 'ब',
  i: 'ष्',
  '‰': 'झ्',
  U: 'ग्',
  Q: 'त्त',
  ']': 'े',
  '˜': 'ऽ',
  Y: 'थ्',
  Ø: '्य',
  E: 'भ्',
  A: 'ब्',
  M: 'ः',
  Ì: 'न्न',
  I: 'क्ष्',
  '5': 'छ',
  '´': 'झ',
  '1': 'ज्ञ',
  '°': 'ङ्ढ',
  '=': '.',
  Æ: '”',
  '‹': 'ङ्घ',
  '%': '५',
  '¤': 'झ्',
  '!': '१',
  '-': '(',
  '›': 'द्र',
  ')': '०',
  '…': '‘',
  Ü: '%'
};

/**
 * Replacement Array
 */
export const replacementRules = [
  ['्ा', ''],
  ['(त्र|त्त)({^उभप}+?)m', '$1m$2'],
  ['त्रm', 'क्र'],
  ['त्तm', 'क्त'],
  ['({^उभप}+?)m', 'm$1'],
  ['उm', 'ऊ'],
  ['भm', 'झ'],
  ['पm', 'फ'],
  ['इ{', 'ई'],
  ['ि((.्)*{^्})', '$1ि'],
  ['(.{ािीुूृेैोौंःँ}*?){', '{$1'],
  ['((.्)*){', '{$1'],
  ['{', 'र्'],
  ['({ाीुूृेैोौंःँ}+?)(्(.्)*{^्})', '$2$1'],
  ['्({ाीुूृेैोौंःँ}+?)((.्)*{^्})', '्$2$1'],
  ['({ंँ})({ािीुूृेैोौः}*)', '$2$1'],
  ['ँँ', 'ँ'],
  ['ंं', 'ं'],
  ['ेे', 'े'],
  ['ैै', 'ै'],
  ['ुु', 'ु'],
  ['ूू', 'ू'],
  ['^ः', ':'],
  ['टृ', 'ट्ट'],
  ['ेा', 'ाे'],
  ['ैा', 'ाै'],
  ['अाे', 'ओ'],
  ['अाै', 'औ'],
  ['अा', 'आ'],
  ['एे', 'ऐ'],
  ['ाे', 'ो'],
  ['ाै', 'ौ']
];
